import * as ACTION from '../constants';
import * as saga from './saga';
import {takeEvery, takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.CREATE_STAFF_IN_WAREHOUSE.REQUEST, saga.createStaffInWarehouse);
	yield takeEvery(ACTION.CREATE_STAFF_IN_WAREHOUSE.SUCCESS, saga.createStaffInWarehouseSuccess);
	yield takeEvery(ACTION.CREATE_STAFF_IN_WAREHOUSE.FAILED, saga.createStaffInWarehouseFailed);
}
